import $ from 'jquery';
import HeaderSticky from "./widgets/header-sticky";
import domEvents from "./modules/dom-events";
import CheckUserLogged from "./widgets/check-user-logged";
import NewsletterSubscription from "./widgets/newsletter-subscription";
import Login from "./widgets/login";
import HeaderUserControls from "./widgets/header-user-controls";

new HeaderSticky();
domEvents.init();

$('[data-id="widget-newsletter-subscription"]').each(function () {
    new NewsletterSubscription(this);
});

$('[data-id="widget-login"]').each(function () {
    new Login(this);
    $(document).on("click", '[data-login-show]', function () {
        let _event = new CustomEvent('render_login_modal');
        document.dispatchEvent(_event);
    });
});

$('[data-id="widget-header-user-controls"]').each(function () {
    new HeaderUserControls(this);
})

$('[data-id="widget-check-user-logged"]').each(function () {
    new CheckUserLogged(this);
});